import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';

// import { Token } from '../../../../models/base/index';

import { Constant, BaseComponent } from '../../../../../infrastructure/common';
import { AuthenticationService } from '../../../../../infrastructure/services/base';

import * as _ from 'lodash';

declare var jQuery: any;

@Component({
    selector: 'page-change-password',
    templateUrl: './change-password.html',
    // providers: [OnlineOrderService],
    styles: [
        `.bg-td{
            background-color: #f2eded;
            padding: 5px;
        }
    `]

})
export class ChangePasswordComponent extends BaseComponent implements OnInit {
    // @Output() onCreateOrder = new EventEmitter<any>();
    // @Output() fillOrderEvent = new EventEmitter<Account>();

    isLoading = false;
    // token: Token;
    // accounts: any[];
    newPassword: string;
    confirmNewPassword: string;

    // constructor(private route: ActivatedRoute, private router: Router, private onlineOrderService: OnlineOrderService) {
    //     super();
    //  }
    constructor(private authenticationService: AuthenticationService) {
        super();
    }

    ngOnInit(): void {
        // if (localStorage.getItem('currentUser') === "null")
        // alert
        //     this.router.navigate(['login']);id
        // this.token = TokenService.getToken();
        // this.loadAccounts();
    }

    changePassword() {
        let self = this;
        this.isLoading = true;

        let userId: string = this.token.UserId;
        this.authenticationService.changePassword(userId, this.newPassword, this.confirmNewPassword)
            .subscribe(
            data => {
                self.isLoading = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                }
                else {
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoading = false;
                self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);

            }
            );
    }

truncateString(str, num) {
      if(str!=null){
        return str.length > num ? str.slice(0, num) + '...' : str;
      } else {
        return ''
      }
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
      let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);
      jQuery('#PopupMessageTitle').html(title);
      jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
      jQuery('#PopupMessage').modal('show');
    }

}



// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/change-password/change-password.component.ts